import { createAction } from '@ngrx/store';

export const addProtection = createAction(
  '[Additional Services] Add Protection'
);
export const resetProtection = createAction(
  '[Additional Services] Reset Protection'
);

export type ProtectionActions = typeof addProtection | typeof resetProtection;
